import { Box, SxProps } from "@mui/material";
import React from "react";
import theme from "Theme/AppTheme";

const FilterSectionContainer = ({
    children,
    sx = {},
}: {
    children: React.ReactNode;
    sx?: SxProps;
}) => {
    return (
        <Box
            sx={{
                p: 1,
                backgroundColor: theme.palette.lightgray.main,
                borderRadius: 1,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default FilterSectionContainer;
